$(document).ready(function () {

    $('.js-expand-question').on('click', function () {

        var question = $(this).closest('.js-question');
        var toggle = question.find('.js-question-toggle');
        var answer = question.find('.js-question-answer');

        //Contract all others
        $('.js-question-answer').removeClass('accordion-info--active');
        $('.js-question-toggle').removeClass('active').html('+');

        //Expand this one
        answer.addClass('accordion-info--active');
        toggle.addClass('active').html('-');


    });

});